import React, { useCallback } from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import {
  Badge,
  Navbar,
  Nav,
  NavDropdown,
  NavItem,
  MenuItem,
  Row,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";

import {
  logoutAction,
  showLoginAction,
  showPreferencesAction,
} from "../actions/index";
import { useShowAds } from "../hooks";
import { HeaderAd, HeaderVideoAd } from "./ads";
import { selectSubscribed } from "../selectors";

const SubscriptionLevelBadge = ({ level }) => (
  <NavItem href="https://www.patreon.com/iborrowdesk" target="_blank">
    <Badge>{level}</Badge>
  </NavItem>
);

const _Navbar = ({
  authenticated,
  username,
  readableSubscriptionLevel,
  subscribed,
  dispatchLogout,
  dispatchShowPreferences,
  dispatchShowLogin,
}) => {
  const { showAds, showVideoAds } = useShowAds();
  const trackVisitedPatreon = useCallback(() => {
    ReactGA.event({
      category: "Conversion",
      action: "Visited Patreon from navbar",
    });
  }, []);

  return (
    <Row>
      <Navbar>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">IBorrowDesk</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            <LinkContainer to="/filter">
              <NavItem>Filter</NavItem>
            </LinkContainer>
            <LinkContainer to="/about">
              <NavItem>About</NavItem>
            </LinkContainer>
            <LinkContainer to="/changelog">
              <NavItem>Changes</NavItem>
            </LinkContainer>
            <LinkContainer to="/faq">
              <NavItem>FAQ</NavItem>
            </LinkContainer>
            <NavItem
              href="https://www.patreon.com/iborrowdesk"
              target="_blank"
              onClick={trackVisitedPatreon}
            >
              Patreon
            </NavItem>
            {subscribed && (
              <LinkContainer to="/premium">
                <NavItem>Full Archive Access</NavItem>
              </LinkContainer>
            )}
            {authenticated && (
              <>
                <LinkContainer to="/watchlist">
                  <NavItem>Watchlist</NavItem>
                </LinkContainer>
                <LinkContainer to="/alerts">
                  <NavItem>Alerts</NavItem>
                </LinkContainer>
              </>
            )}
          </Nav>
          <Nav pullRight>
            {authenticated && (
              <NavDropdown title={username || ""} id="nav-dropdown">
                <MenuItem href="#" onClick={dispatchLogout}>
                  Logout
                </MenuItem>
                <MenuItem onClick={dispatchShowPreferences}>
                  Preferences
                </MenuItem>
              </NavDropdown>
            )}
            {readableSubscriptionLevel && (
              <SubscriptionLevelBadge level={readableSubscriptionLevel} />
            )}
            {!authenticated && (
              <LinkContainer to="/register">
                <NavItem>Register</NavItem>
              </LinkContainer>
            )}
            {!authenticated && (
              <NavItem onClick={dispatchShowLogin}>Login</NavItem>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {showAds && !showVideoAds && <HeaderAd />}
      {showVideoAds && <HeaderVideoAd />}
    </Row>
  );
};

const mapStateToProps = (state) => ({
  authenticated: state.auth.authenticated,
  username: state.auth.username,
  readableSubscriptionLevel: state.auth.readableSubscriptionLevel,
  subscribed: selectSubscribed(state),
  message: state.message,
});

export default connect(mapStateToProps, {
  dispatchLogout: logoutAction,
  dispatchShowLogin: showLoginAction,
  dispatchShowPreferences: showPreferencesAction,
})(_Navbar);
